/**
 * @generated SignedSource<<83bca6ed6b500f89aa5c538b6fa1f1b5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DashboardUserStudentBackEndQuery$variables = {
  publicUserId: string;
};
export type DashboardUserStudentBackEndQuery$data = {
  readonly isInternalUser: boolean;
  readonly userByPublicUserId: {
    readonly firstName: string | null | undefined;
    readonly gradeLevels: ReadonlyArray<{
      readonly id: string;
      readonly name: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly id: string;
    readonly lastName: string | null | undefined;
    readonly roles: ReadonlyArray<{
      readonly name: string | null | undefined;
      readonly summary: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly sites: ReadonlyArray<{
      readonly id: string;
      readonly name: string | null | undefined;
      readonly network: {
        readonly customBranding: string | null | undefined;
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
      readonly siteSchoolYears: ReadonlyArray<{
        readonly startOn: any;
      } | null | undefined> | null | undefined;
      readonly standardState: {
        readonly id: string;
        readonly stateStandardName: string | null | undefined;
      } | null | undefined;
      readonly targetGroups: ReadonlyArray<{
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly timeZone: {
        readonly name: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly userGuidingHash: string;
};
export type DashboardUserStudentBackEndQuery = {
  response: DashboardUserStudentBackEndQuery$data;
  variables: DashboardUserStudentBackEndQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "publicUserId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userGuidingHash",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInternalUser",
  "storageKey": null
},
v3 = [
  {
    "kind": "Variable",
    "name": "publicUserId",
    "variableName": "publicUserId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = [
  (v4/*: any*/),
  (v7/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "GradeLevelNode",
  "kind": "LinkedField",
  "name": "gradeLevels",
  "plural": true,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "summary",
  "storageKey": null
},
v11 = [
  {
    "kind": "Literal",
    "name": "sitesFilter",
    "value": {
      "isActive": "ACTIVE"
    }
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startOn",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "TargetGroupNode",
  "kind": "LinkedField",
  "name": "targetGroups",
  "plural": true,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "StandardStateNode",
  "kind": "LinkedField",
  "name": "standardState",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "stateStandardName",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "NetworkNode",
  "kind": "LinkedField",
  "name": "network",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customBranding",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardUserStudentBackEndQuery",
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "UserNode",
        "kind": "LinkedField",
        "name": "userByPublicUserId",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RoleNode",
            "kind": "LinkedField",
            "name": "roles",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v11/*: any*/),
            "concreteType": "SiteNode",
            "kind": "LinkedField",
            "name": "sites",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SiteSchoolYearNode",
                "kind": "LinkedField",
                "name": "siteSchoolYears",
                "plural": true,
                "selections": [
                  (v12/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TimeZoneNode",
                "kind": "LinkedField",
                "name": "timeZone",
                "plural": false,
                "selections": [
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/)
            ],
            "storageKey": "sites(sitesFilter:{\"isActive\":\"ACTIVE\"})"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DashboardUserStudentBackEndQuery",
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "UserNode",
        "kind": "LinkedField",
        "name": "userByPublicUserId",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RoleNode",
            "kind": "LinkedField",
            "name": "roles",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v10/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v11/*: any*/),
            "concreteType": "SiteNode",
            "kind": "LinkedField",
            "name": "sites",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SiteSchoolYearNode",
                "kind": "LinkedField",
                "name": "siteSchoolYears",
                "plural": true,
                "selections": [
                  (v12/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TimeZoneNode",
                "kind": "LinkedField",
                "name": "timeZone",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/)
            ],
            "storageKey": "sites(sitesFilter:{\"isActive\":\"ACTIVE\"})"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8d74502ea5f89472b9b3f7044e036831",
    "id": null,
    "metadata": {},
    "name": "DashboardUserStudentBackEndQuery",
    "operationKind": "query",
    "text": "query DashboardUserStudentBackEndQuery(\n  $publicUserId: String!\n) {\n  userGuidingHash\n  isInternalUser\n  userByPublicUserId(publicUserId: $publicUserId) {\n    id\n    firstName\n    lastName\n    gradeLevels {\n      id\n      name\n    }\n    roles {\n      name\n      summary\n      id\n    }\n    sites(sitesFilter: {isActive: ACTIVE}) {\n      id\n      name\n      siteSchoolYears {\n        startOn\n        id\n      }\n      timeZone {\n        name\n        id\n      }\n      targetGroups {\n        id\n        name\n      }\n      standardState {\n        id\n        stateStandardName\n      }\n      network {\n        id\n        name\n        customBranding\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3fd16c3aceaa35b7a05c008e9678a370";

export default node;
